import { QueryParams } from "../type";

export const TEAM_KEYS = {
  TEAM: "TEAM",
  GET_TEAMS: (params?: QueryParams) => [`${TEAM_KEYS.TEAM}/list`, params],
  GET_TEAM_BY_ID: (id: string) => [`${TEAM_KEYS.TEAM}/detail`, id],
  CREATE_TEAM: () => [TEAM_KEYS.TEAM, "create"],
  UPDATE_TEAM: () => [TEAM_KEYS.TEAM, "update"],
  DELETE_TEAM: () => [TEAM_KEYS.TEAM, "delete"],
};
